import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.GmbMultiLocationPosts = routerStyxie({ actions: ['index', 'show', 'new']})
